__turbopack_context__.v({
  "root": "DetailsSectionHeader-module-scss-module__Pz67TW__root",
  "title": "DetailsSectionHeader-module-scss-module__Pz67TW__title",
});
